import api from './api';
import { Team, TeamCreate, TeamUpdate, TeamAnalysis } from '../types/team';

export async function getTeams(tag?: string): Promise<Team[]> {
  const params = tag ? { tag } : {};
  const response = await api.get('/teams', { params });
  return response.data;
}

export async function getTeam(id: string): Promise<Team> {
  const response = await api.get(`/teams/${id}`);
  return response.data;
}

export async function createTeam(team: TeamCreate): Promise<Team> {
  const response = await api.post('/teams', team);
  return response.data;
}

export async function updateTeam(id: string, team: TeamUpdate): Promise<Team> {
  const response = await api.put(`/teams/${id}`, team);
  return response.data;
}

export async function deleteTeam(id: string): Promise<void> {
  await api.delete(`/teams/${id}`);
}

export async function analyzeTeam(id: string): Promise<TeamAnalysis> {
  const response = await api.get(`/teams/${id}/analysis`);
  return response.data;
}
